import whereMoneyGoes from "./where_money_goes.png";
import desktop1 from "./desktopDetailed6.png";

import start_small from "./start_small.png";
import desktop2 from "./desktopDetailed5.png";

import who_are_we from "./who_are_we.png";
import desktop3 from "./desktopDetailed3.png";

import scale_beyond_mvp from "./scale_beyond_mvp.png";
import desktop4 from "./desktopDetailed4.png";

import confusion_to_creation from "./confusion_to_creation.png";
import dektop5 from "./desktopDetailed5.png";

import concept from "./concept.png";
import desktop6 from "./desktopDetailed4.png";

import greenFlyingMoney from "./greenFlyingMoney.png";
import desktop7 from "./desktopDetailed7.png";

import taxIsland from "./taxIsland.png";
import desktop8 from "./desktopDetailed8.png";

import siren from "./siren.png";
import desktop9 from "./desktopDetailed9.png";

import creditScore from "./creditScore.png";
import desktop10 from "./desktopDetailed10.png";

import dreamBike from "./dreamBike.png";
import desktop11 from "./desktopDetailed11.png";

import tinyChanges from "./tinyChanges.png";
import desktop12 from "./desktopDetailed612.png";

import loanApplication from "./loanApplication.png";
import desktop13 from "./desktopDetailed13.png";

import bestInvestment from "./bestInvestment.png";
import desktop14 from "./desktopDetailed14.png";

import taxCalulator from "./tax-calculator.png";
import desktop15 from "./desktopDetailed15.png";

import walletMoney from "./wallet-money.png";
import desktop16 from "./desktopDetailed16.png";

import desktop17 from "./desktop17.png";
import desktopDetailed17 from "./desktopDetailed17.png";

import desktop18 from "./desktop18.png";
import desktopDetailed18 from "./desktopDetailed18.png";

const blogData = [
  {
    id: 1,
    slug: "why-your-salary-disappears-even-before-you-see-it",
    readTime: "3 min read",
    mainTitle: "Understand where your money goes",
    mainTitlePage: "Why your salary disappears even before you see it",
    image: whereMoneyGoes,
    detailImage: desktop1,
    imageAlt: "3D illustration of money going down a purple arrow",
    category: "Knowledge",
    headline: "Why your salary disappears even before you see it",
    excerpt: "Every month, you think,This time I'll save something.",
    publishDate: "November 6, 2025",
  },
  {
    id: 2,
    slug: "can-micro-savings-make-you-richer",
    readTime: "4 min read",
    mainTitle: "Start small, grow big",
    mainTitlePage: "Can Micro-Savings Make You Richer?",
    image: start_small,
    detailImage: desktop2,
    imageAlt: "3D illustration of money going down a purple arrow",
    category: "Knowledge",
    headline: "Can Micro-Savings Make You Richer?",
    excerpt:
      "Salary aate hi khatam ho jaati hai Par kya agar har mahine thoda sa save ho jaye? ",
    publishDate: "November 12, 2025",
  },
  {
    id: 3,
    slug: "kPaisa-Simplifying-finance-for-India",
    readTime: "3 min read",
    mainTitle: "Who are we?",
    mainTitlePage: "kPaisa: Simplifying finance for India",
    image: who_are_we,
    detailImage: desktop3,
    imageAlt: "3D illustration of money going down a purple arrow",
    category: "Knowledge",
    headline: "kPaisa: Simplifying finance for India",
    excerpt:
      "kPaisa is helping shape a quiet financial shift happening across India. Mutual fund",
    publishDate: "November 17, 2025",
    // This 'content' field holds the full HTML for the blog post page
  },
  {
    id: 4,
    slug: "beyond-mvp-the-exciting-road-to-revenue",
    readTime: "5 min read",
    mainTitle: "Scale Beyond MVP",
    mainTitlePage: "Beyond MVP: The Exciting Road to Revenue!",
    image: scale_beyond_mvp,
    detailImage: desktop4,
    imageAlt: "3D illustration of money going down a purple arrow",
    category: "Knowledge",
    headline: "Beyond MVP: The Exciting Road to Revenue!",
    excerpt: "as of date 31st December 2023 kPaisa has 52,782 use..",
    publishDate: "December 31, 2023",
  },
  {
    id: 5,
    slug: "idea-to-mvp",
    readTime: "3 min read",
    mainTitle: "Concept to Creation",
    mainTitlePage: "Idea to MVP",
    image: concept,
    detailImage: dektop5,
    imageAlt: "3D illustration of money going down a purple arrow",
    category: "Knowledge",
    headline: "Idea to MVP",
    excerpt:
      "This Article is a Consolidation of our Past 1 year of Learning to Build an Approximate Product...",
    publishDate: "December 28, 2023",
    // This 'content' field holds the full HTML for the blog post page
  },
  {
    id: 6,
    slug: "23-and-a-startup",
    readTime: "3 min read",
    mainTitle: "From Confusion to Creation",
    mainTitlePage: "23 and a startup!",
    image: confusion_to_creation,
    detailImage: desktop6,
    imageAlt: "3D illustration of money going down a purple arrow",
    category: "Knowledge",
    headline: "23 and a startup!",
    excerpt:
      "We all go through a moment in our lives where we believe we are better than everyone...",
    publishDate: "September 19, 2021",
    // This 'content' field holds the full HTML for the blog post page
  },
  {
    id: 7,
    slug: "funny-how-we-remember-who-owes-us-money-but-not-wh",
    readTime: "2 min read",
    mainTitle: "See where Your money vanishes",
    mainTitlePage:
      "Knowledge Funny How We Remember Who Owes Us Money, But Not Wh...",
    image: greenFlyingMoney,
    detailImage: desktop7,
    imageAlt: "greenFlyingMoney",
    category: "Knowledge",
    headline:
      "Knowledge Funny How We Remember Who Owes Us Money, But Not Wh...",
    excerpt:
      "You remember the friend who still owes you ₹200. But not the dozen ₹20 spent that quietly disappeared this..",
    publishDate: "December 8, 2025",
    // This 'content' field holds the full HTML for the blog post page
  },
  {
    id: 8,
    slug: "how-to-afford-that-dream-vacation-without-draining-your-wallet",
    readTime: "2 min read",
    mainTitle: "Small saves, Big journeys",
    mainTitlePage:
      "How to Afford That Dream Vacation - Without Draining Your Wallet",
    image: taxIsland,
    detailImage: desktop8,
    imageAlt: "taxIsland",
    category: "Knowledge",
    headline:
      "How to Afford That Dream Vacation - Without Draining Your Wallet",
    excerpt:
      "Foreign trip ka sapna sabka hota hai - Eiffel Tower, Santorini sunsets, or Singapore shopping...",
    publishDate: "December 3, 2025",
    // This 'content' field holds the full HTML for the blog post page
  },
  {
    id: 9,
    slug: "what-if-you-never-had-to-worry-about-surprise-expenses-again",
    readTime: "2 min read",
    mainTitle: "Be ready for emergencies",
    mainTitlePage:
      "What If You Never Had to Worry About Surprise Expenses Again?",
    image: siren,
    detailImage: desktop9,
    imageAlt: "siren",
    category: "Knowledge",
    headline: "What If You Never Had to Worry About Surprise Expenses Again?",
    excerpt:
      "Every month, something shows up that you didn’t plan for A school form fee. A small...",
    publishDate: "November 28, 2025",
    // This 'content' field holds the full HTML for the blog post page
  },
  {
    id: 10,
    slug: "boost-your-credit-score-a-step-by-step-guide-for-new-borrowers",
    readTime: "3 min read",
    mainTitle: "Small habits, big score",
    mainTitlePage:
      "Boost Your Credit Score - A Step-by-Step Guide for New Borrowers",
    image: creditScore,
    detailImage: desktop10,
    imageAlt: "creditScore",
    category: "Knowledge",
    headline:
      "Boost Your Credit Score - A Step-by-Step Guide for New Borrowers",
    excerpt: "Your credit score decides whether banks trust you or n...",
    publishDate: "January 28, 2026",
    // This 'content' field holds the full HTML for the blog post page
  },
  {
    id: 11,
    slug: "your-dream-bike-is-closer-than-you-think",
    readTime: "2 min read",
    mainTitle: "Ride without regrets",
    mainTitlePage: "Your Dream Bike Is Closer Than You Think",
    image: dreamBike,
    detailImage: desktop11,
    imageAlt: "dreamBike",
    category: "Knowledge",
    headline: "Your Dream Bike Is Closer Than You Think",
    excerpt: "Whether you’re a fresher with your first sl...",
    publishDate: "January 28, 2026",
    // This 'content' field holds the full HTML for the blog post page
  },
  {
    id: 12,
    slug: "tiny-changes-real",
    readTime: "3 min read",
    mainTitle: "Tiny amounts, Real growth",
    mainTitlePage:
      "The Bank Won’t Tell You This: Turn Spare Change into Gold (Seriously)",

    metaTitle:
      "Best Investment Options in India 2026 for Beginners & Young Investors",
    metaDescription:
      "Discover the best investment options in India 2026 including SIPs, mutual funds, FDs, digital gold and P2P lending. Smart strategies for young investors.",
    primaryKeywords:
      "Investment options India, Best investment in India 2026, SIP investment, Mutual funds India,Investment app India",
    secondaryKeywords:
      "Where to invest money in India, Safe investment options India, High return investments India, Investment for beginners India, Digital gold investment",

    image: tinyChanges,
    detailImage: desktop12,
    imageAlt: "siren",
    category: "Knowledge",
    headline:
      "The Bank Won’t Tell You This: Turn Spare Change into Gold (Seriously)",
    excerpt: "Long queues. Forms that never end. Hidden fees that surpris...",
    publishDate: "January 28, 2026",
    // This 'content' field holds the full HTML for the blog post page
  },
  {
    id: 13,
    slug: "personal-loans-india-2026",
    readTime: "2 min read",
    mainTitle: "2026 guide to personal loans",
    mainTitlePage:
      "Personal Loans in India 2026: Trends, Data & Smart Borrowing Tips",

    //seo meta
    metaTitle:
      "Personal Loans in India 2026: Trends, Interest Rates & Smart Tips",
    metaDescription:
      "Explore personal loan trends in India 2026, latest interest rates, digital lending growth, and smart borrowing tips to choose the best loan option.",
    primaryKeywords:
      "Personal loans India, Personal loan interest rates 2026, Instant loan app India, Online personal loan, Digital lending India",
    secondaryKeywords:
      "How to get personal loan in India, Best personal loan app in India, Personal loan eligibility criteria, RBI loan rules 2026, Low interest personal loan India",

    image: loanApplication,
    detailImage: desktop13,
    imageAlt: "loanApplication",
    category: "Knowledge",
    headline:
      "Personal Loans in India 2026: Trends, Data & Smart Borrowing Tips",
    excerpt:
      "Personal loans have become one of the fastest-growing credit products in...",
    publishDate: "February 17, 2026",
  },
  {
    id: 14,
    slug: "top-investment-options-india-2026",
    readTime: "3 min read",
    mainTitle: "Best investments options 2026",
    mainTitlePage:
      "Top Investment Options in India 2026: A Guide for Young Investors",

    metaTitle:
      "Best Investment Options in India 2026 for Beginners & Young Investors",
    metaDescription:
      "Discover the best investment options in India 2026 including SIPs, mutual funds, FDs, digital gold and P2P lending. Smart strategies for young investors.",
    primaryKeywords:
      "Investment options India, Best investment in India 2026, SIP investment, Mutual funds India,Investment app India",
    secondaryKeywords:
      "Where to invest money in India, Safe investment options India, High return investments India, Investment for beginners India, Digital gold investment",

    image: bestInvestment,
    detailImage: desktop14,
    imageAlt: "bestInvestment",
    category: "Knowledge",
    headline:
      "Top Investment Options in India 2026: A Guide for Young Investors",
    excerpt: "With growing financial awareness and a...",
    publishDate: "February 17, 2026",
  },
  {
    id: 15,
    slug: "smart-credit-strategies-india-2026",
    readTime: "3 min read",
    mainTitle: "Smart Credit Strategies 2026",
    mainTitlePage: "Smart Credit Strategies in India for 2026",

    metaTitle: "Smart Credit Strategies India 2026 | Credit Cards & BNPL Guide",
    metaDescription:
      "Learn how to use credit cards and BNPL smartly in India 2026. Protect your credit score, avoid debt traps, and build a strong financial future.",
    primaryKeywords:
      "Smart credit strategy India, Credit card tips India 2026, BNPL India, Credit score India, How to use credit cards wisely",
    secondaryKeywords:
      "Credit utilisation India, Avoid debt trap India, BNPL credit score effect, Personal loan tips India, Credit management beginners",

    image: taxCalulator,
    detailImage: desktop15,
    imageAlt: "Smart Credit Strategies 2026",
    category: "Knowledge",
    headline: "Smart Credit Strategies in India for 2026",
    excerpt: "Credit in India has become faster and...",
    publishDate: "February 27, 2026",
  },
  {
    id: 16,
    slug: "financial-planning-checklist-india-2026",
    readTime: "3 min read",
    mainTitle: "Financial planning for young india",
    mainTitlePage:
      "Financial Planning Checklist for Millennials and Gen Z in India 2026: A Practical Guide to Building Wealth in a Fast Moving Financial World",

    metaTitle:
      "Financial Planning Checklist for Millennials and Gen Z in India 2026",
    metaDescription:
      "A practical financial planning checklist for Millennials and Gen Z in India in 2026. Learn budgeting, investing, emergency funds, debt management, and wealth building strategies.",
    primaryKeywords:
      "Financial planning checklist India 2026, Financial planning for millennials India, Money management tips 2026, Investment planning India, Budgeting strategy India",
    secondaryKeywords:
      "Millennials finance India, Gen Z money tips, Wealth building India, Personal finance India, Emergency fund India",

    image: walletMoney,
    detailImage: desktop16,
    imageAlt: "financial planning checklist millennials gen z india 2026",
    category: "Knowledge",
    headline:
      "Financial Planning Checklist for Millennials and Gen Z in India 2026",
    excerpt: "In 2026, earning money is not enough..",
    publishDate: "February 27, 2026",
  },
  {
    id: 17,
    slug: "india-credit-growth-2026-trends",
    readTime: "3 min read",
    mainTitle: "The 2026 credit shift in india",
    mainTitlePage:
      "India Is Borrowing More Than Ever: The Hidden Credit Shift in 2026",

    metaTitle: "India Credit Growth 2026: Trends, Risks & Borrowing Behavior",
    metaDescription:
      "Explore India’s rising credit trends in 2026, the growth of BNPL, and how changing borrowing behavior is shaping financial decisions.",
    primaryKeywords:
      "India credit growth, BNPL India, Digital lending India ,Consumer borrowing trends, Credit usage India",
    secondaryKeywords:
      "Why credit is increasing in India, BNPL impact on Indian consumers, Digital lending trends India 2026, How Indians are borrowing in 2026, Hidden debt India",

    image: desktop17,
    detailImage: desktopDetailed17,
    imageAlt: "India Credit Growth 2026: Trends, Risks & Borrowing Behavior",
    category: "Knowledge",
    headline:
      "India Is Borrowing More Than Ever: The Hidden Credit Shift in 2026",
    excerpt: "India is witnessing a sharp rise in consu..",
    publishDate: "March 27, 2026",
  },
  {
    id: 18,
    slug: "financial-planning-india-why-wealth-not-increasing",
    readTime: "3 min read",
    mainTitle: "Why isnt india getting wealthier",
    mainTitlePage:
      "India Has More Financial Tools Than Ever: So Why Isn’t Wealth Increasing",

    metaTitle: "Financial Planning India 2026: Why Wealth Is Not Increasing ",
    metaDescription:
      "Discover why financial planning fails in India despite better tools and access. Learn key gaps in money management and wealth building strategies.",
    primaryKeywords:
      "Financial planning India, Wealth building India, Money management India, Personal finance India",
    secondaryKeywords:
      "Why people fail financially India, Financial mistakes millennials India, How to build wealth in India, Money habits India 2026",

    image: desktop18,
    detailImage: desktopDetailed18,
    imageAlt: "Why isnt india getting wealthier",
    category: "Knowledge",
    headline: "Why isnt india getting wealthier",
    excerpt: "India’s financial ecosystem has evolved..",
    publishDate: "March 27, 2026",
  },
];

export default blogData;
